export const PromoCodes = [
  'wwwsupporter',
  'wwwavidsupporter',
  'wwwmember',
  'sheeo',
  'nawbo',
  'watermark',
  'sba'
];



// WEBPACK FOOTER //
// ./src/utils/bfwPromoCodes.js